<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-lightborder table-striped">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Usuario</th>
          <th>Fecha Creacion</th>
          <th>Fecha</th>
          <th class="text-center">Estado</th>
          <th class="text-center" style="width: auto;"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id">
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td>
            <timeago :title="current.fecha_creacion" :datetime="current.fecha_creacion"></timeago>
          </td>
          <td>{{ current.fecha }}</td>
          <td class="text-center">
            <div data-title="Activo" data-toggle="tooltip" v-html="current.estado_str"></div>
          </td>
          <td class="text-center">
          <div class="btn-group">
            <button
              aria-expanded="false"
              aria-haspopup="true"
              class="btn btn-sm btn-warning mr-1 dropdown-toggle"
              data-toggle="dropdown"
              type="button"
            >
              <i class="fa fa-paper-plane"></i>
              Acción
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuLink"
            >
              <a 
                class="dropdown-item" 
                @click="irAEsconderModal('compras-reqcompra-editar', { id: current.id })"
              >Ver
              <i class="fa fa-eye"></i>
              </a
              >
              <a 
                class="dropdown-item" 
                v-if="current.estado == 'B'"
                @click="generar_cotizacion(current)"
                >Cotización
                <i class="fa fa-share"></i>
                </a
              >
            </div>
          </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="onPageChange" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import ReqCompraService from "@/services/compras/ReqCompraService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: []
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "reqcompras/reqs_compras"
    })
  },
  mounted() {
    this.$store.dispatch("reqcompras/fetch");
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("reqcompras/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext
      });
    },
    customFormatterInverted(date) {
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d)
        .add(1, "days")
        .format("YYYY-MM-DD");
    },
    irAEsconderModal(name, params) {
      if($('.modal').hasClass('show')){
        $('.modal').find('.close').click();
      }
      this.$router.push({
        name: name,
        params: params
      });
    },
    generar_cotizacion(current) {
      /**
       * Genera una cotización basada en el requerimiento de compra
       */
      let self = this;
      ReqCompraService.generar_cotizacion(current.id)
        .then(response => {
          let id_cot = response.data.cotizacion_e;
          Notifications.alert.confirm(
            "Cotización Generada",
            "Ir a la Cotizacion Generada",
            "",
            function() {
              self.irAEsconderModal("compras-cotizaciones-editar", { id: id_cot });
            }
          );
        })
        .catch(error => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
      
    },
  }
};
</script>
